// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"060e9c0b","130":"9fe89706","149":"65f091cf","156":"f699d5ca","181":"74711140","283":"00fef269","319":"434ddc6e","372":"7ca6508e","378":"6ac2c797","408":"356119c0","437":"1b795882","596":"27794edf","839":"0bfc8a87","942":"80bc42eb"}[chunkId] + ".chunk.js";
};